import { sub } from 'date-fns';

const Today = new Date();
Today.setHours(0, 0, 0, 0);

export const AuthenticationPlusCompliantOptions = [
  {
    label: 'Yes',
    value: 'true',
  },
  {
    label: 'No',
    value: 'false',
  },
];

export const DateRangePresets = [
  {
    label: 'Today',
    start: Today,
    end: Today,
  },
  {
    label: 'Last 7 days',
    start: sub(Today, { days: 7 }),
    end: Today,
  },
  {
    label: 'Last 1 month',
    start: sub(Today, { months: 1 }),
    end: Today,
  },
  {
    label: 'Last 6 months',
    start: sub(Today, { months: 6 }),
    end: Today,
  },
];

export const EntityTypeOptions = [
  {
    label: 'PUBLIC_PROFIT',
    value: 'PUBLIC_PROFIT',
  },
  {
    label: 'PRIVATE_PROFIT',
    value: 'PRIVATE_PROFIT',
  },
  {
    label: 'NON_PROFIT',
    value: 'NON_PROFIT',
  },
  {
    label: 'GOVERNMENT',
    value: 'GOVERNMENT',
  },
  {
    label: 'SOLE_PROPRIETOR',
    value: 'SOLE_PROPRIETOR',
  },
];

export const GermanyPOCEntityTypeOptions = [
  {
    label: 'PUBLIC_PROFIT',
    value: 'PUBLIC_PROFIT',
  },
  {
    label: 'PRIVATE_PROFIT',
    value: 'PRIVATE_PROFIT',
  },
];
